export const SDK_VERSION = '6.7.1';
